import React,{useState} from "react";
import { IconButton } from "@mui/material";
import './MessageBox.css'
import {GrFormClose} from 'react-icons/gr';
import {FaExpandAlt} from 'react-icons/fa';
import {IoClose,} from 'react-icons/io5';
import {IoMdAttach} from 'react-icons/io';
import {HiMinus} from 'react-icons/hi';
import {Modal} from 'antd';

import { Input } from 'antd';

const { TextArea } = Input;




function MessageBox({visible}){

    const [message_box,setmessage_box] = useState(true)


    console.log('chatmodal',visible)

    return(
        <div style={{width:'100%',height:'100%'}}>
        {/* <Modal
        centered
        width={1000}
        height={'80%'}
        style={{backgroundColor:'white'}}
        footer={null}
        closable={false}
        visible={true}>
            <div style={{height:500,position:'relative'}}>
                <div className="chatbox_header">
                    <h6>Company Name </h6>
                    <div style={{width:'80px',display:'flex',justifyContent:'space-evenly'}}>
                        <HiMinus  size={13} color="white" className="icon_in_chat"/>
                        <FaExpandAlt size={12} color="white" className="icon_in_chat"/>
                        <IoClose size={13} color="white" className="icon_in_chat" />
                    </div>
                </div>

                <div className="message_section"> 


<div className="message_box_receive">
  <p className="arrow_up_message"></p>
  <h4>Krishna Prasad</h4>

   <h6>Krishna loves you here</h6>

   <span>12th Aug</span>
</div>


<div className="message_box_send">
  <p className="arrow_up_message1"></p>
  <h4>Krishna Prasad</h4>

   <h6>Krishna loves you here</h6>

   <span>12th Aug</span>
</div>

</div>

<div className="message_footer_chat">
  <input type={'text'} placeholder="Type a message" className="input_style" />
  <IoMdAttach size={18} className="icon_in_chat" />
</div>

            </div>
        </Modal> */}
       {visible &&
         <div className={!message_box ? "messagebox_outer" : "messagebox_outer1" }>
             <div className="chatbox_header">
                <h6>Company Name </h6>
                <div style={{width:'60px',display:'flex',justifyContent:'space-evenly'}}>
                    <HiMinus  size={13} color="white" className="icon_in_chat" onClick={()=>setmessage_box(!message_box)}/>
                    {/* <FaExpandAlt size={12} color="white" className="icon_in_chat"/> */}
                    <IoClose size={13} color="white" className="icon_in_chat" />
                </div>
             </div>

           {!message_box && <>
             <div className="message_section"> 


              <div className="message_box_receive">
                <p className="arrow_up_message"></p>
                <h4>Krishna Prasad</h4>

                 <h6>Krishna loves you here</h6>

                 <span>12th Aug</span>
              </div>


              <div className="message_box_send">
                <p className="arrow_up_message1"></p>
                <h4>Krishna Prasad</h4>

                 <h6>Krishna loves you here</h6>

                 <span>12th Aug</span>
              </div>

             </div>

             <div className="message_footer_chat">
                <input type={'text'} placeholder="Type a message" className="input_style" />
                <IoMdAttach size={18} className="icon_in_chat" />
            </div>
            </>}
         </div>
         }
         </div>
    )
}

export default MessageBox